import Header from 'components/VerticalLayout/Header'
import React, { useEffect, useState } from 'react'
import bgImage from "../../../assets/images/bgImage1.jpg";
import { Button, Card, CardHeader, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Spinner } from 'reactstrap';
import { Table,Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import AddEditForm from './Components/AddEditForm';
import useListProducts from './Hooks/useListProducts';
import SwitchButton from './Components/SwitchButton';
import useDisableProduct from './Hooks/useDisableProduct';

 // Style object for the sticky table headers
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
  };

const ProductsCustomizationPage = () => {

  // pagination
  const[currentPage,setCurrentPage] = useState(1);
  const pageSize = 10;
  // search
  const[searchTerm,setSearchTerm]=useState('');

  // custom hook to get the produt data
  const{isPending,isSuccess,isError,error,data} = useListProducts(currentPage,pageSize,searchTerm);
  // custom hook for product status update
  const{isDisabling,isDisabled,disableProduct} = useDisableProduct();

  const products = data?.results || [];
  const totalCount = data?.count || 0;
  const totalPages = Math.ceil(totalCount/pageSize);

  // for modal
  const[isOpen,setIsOpen]=useState(false);
  // state to find whether its add or edit
  const[isEditMode,setIsEditMode]=useState(false);
  // store product data for editing
  const[selectedProduct,setSelectedProduct]=useState(null);

  // product status handling
  const[productStatus,setProductStatus]=useState([]);
  const handleToggle=(id)=>{
    setProductStatus((prev)=>
      prev.map((product)=>
        product.id === id ? {...product, is_active: !product.is_active} : product
      )
    )

    console.log("api call")
    disableProduct(id);
  }

  useEffect(()=>{
    setProductStatus(products)
  },[products])

  const AddModal=()=>{
    setIsEditMode(false);
    setSelectedProduct(null);
    setIsOpen(true);
  }

  const EditModal=(product)=>{
    setIsEditMode(true);
    setSelectedProduct(product);
    setIsOpen(true);
  }

  const closeModal=()=>{
    setIsEditMode(false);
    setSelectedProduct(null);
    setIsOpen(false);
  }

  return (
    <div className='account'>
      <Header/>
      <div className='accountbg'
        style={{
                background: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment:"fixed",
                paddingTop:"80px",
                minHeight:"100vh",
                overflow:"hidden",
                paddingLeft:"8px"
                }}
      >
        <Card className='p-4'>
          <div className="pb-2 mb-0 d-flex justify-content-between align-items-center">
              <div>
                <h5 className="fw-bold">Product Customization</h5>
                <p className='text-muted mb-0' style={{fontSize:'0.7rem'}}>Add and Edit Products</p>
              </div>
              <div>
                <Button style={{backgroundColor: "#00ADF0", color: "white",fontWeight: "bolder" }} outline
                  onClick={AddModal}
                >
                  Add Product
                </Button>
              </div>
          </div>
          <div className='table-rep-plugin table-responsive mb-0' style={{maxHeight:"500px",minHeight:"340px",overflowY:"auto"}}>
                <Table className='table table-striped table-bordered'>
                <Thead>
                  <Tr>
                    <Th style={stickyHeaderStyle}>SL No</Th>
                    <Th style={stickyHeaderStyle}>Product Name</Th>
                    <Th style={stickyHeaderStyle}>Status</Th>
                    <Th style={stickyHeaderStyle}>Default Price</Th>
                    <Th style={stickyHeaderStyle}>Actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {isPending && (
                    <Tr>
                      <Td colSpan="5" className="text-center">
                        <Spinner color="primary" />
                      </Td>
                    </Tr>
                  )}
                  
                  {
                    isError && (
                      <Tr>
                        <Td colSpan="18" className="text-center text-danger">
                          <h6>Error fetching data: {error.message}</h6>
                        </Td>
                      </Tr>
                    )
                  }
                  
                {
                  !isPending && products.length === 0 && (
                    <Tr>
                      <Td colSpan="18" className="text-center">
                        <div className="py-4">
                            <div className="d-flex flex-column align-items-center text-muted">
                            <i className="bi bi-exclamation-circle fs-1 mb-2"></i>
                            <h5 className="mb-1">No Data Found</h5>
                            </div>
                        </div>
                      </Td>
                      </Tr>
                  )
                }

                {
                  isSuccess && (
                    Array.isArray(products) && 
                    productStatus.filter((product)=>{
                      const term = searchTerm.toLowerCase();
                      return (product.product_name?.toLowerCase().includes(term))
                    }).map((product,index)=>(
                      <Tr key={index}>
                        <Td>{index + 1}</Td>
                        {/* <Td>{product.product_name}</Td> */}
                        <Td>
                          {product.product_name.startsWith("DA")
                            ? product.product_name.replace("DA", "Desktop Appraisal")
                            : product.product_name}
                        </Td>
                        {/* status */}
                        <Td>
                            <SwitchButton disabled={isDisabling} checked={product.is_active}
                              onChange={()=> handleToggle(product.id)}
                            />
                        </Td>
                        <Td>$ {product.default_price}</Td>
                        <Td>
                          <div style={{ display: "flex", flexDirection: "row",alignItems:"center", gap:"0.5rem"}}>
                            <Button
                              style={{backgroundColor: "#00ADF0", color: "white",fontWeight: "bolder" }}
                              size="sm"
                              outline
                              onClick={() => EditModal(product)}
                            >
                              {<FaEdit/>}
                            </Button>
                            {/* delbutton */}
                            {/* <Button 
                              color="danger" outline size="sm" type="button"
                              // onClick={()=> deleteOrg(org.org_id)}
                            >
                              <FaTrashAlt/>
                            </Button> */}
                          </div>
                        </Td>
                    </Tr>
                  )
                    
                    ))
                }
                  
                </Tbody>
          </Table>
          <div style={{display:"flex", flexDirection:"row", alignItems:"end", justifyContent:"end"}}>
              <Pagination size='sm' className='justify-content-center'>
                {/* first page */}
                <PaginationItem disabled={currentPage === 1}>
                  <PaginationLink
                    first
                    onClick={()=> setCurrentPage(1)}
                    style={{
                      backgroundColor: '#f8f9fa',
                      color: '#007bff',
                      border: '1px solid #dee2e6',
                      padding: '5px 10px',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                    }}
                  />
                </PaginationItem>

                {/* previous page */}
                <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={()=>setCurrentPage(prev => prev - 1)}
                      style={{
                        backgroundColor: '#f8f9fa',
                        color: '#007bff',
                        border: '1px solid #dee2e6',
                        padding: '5px 10px',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                    }}
                    />
                </PaginationItem>

                {/* page numbers */}
                {[...Array(totalPages)].map((_,index)=>{
                  const isActive = currentPage === index + 1;
                  return(
                    <PaginationItem key={index} active={isActive}>
                      <PaginationLink
                        onClick={()=> setCurrentPage(index + 1)}
                        style={{
                          backgroundColor: isActive ? '#007bff' : '#fff',
                          color: isActive ? '#fff' : '#007bff',
                          border: '1px solid #dee2e6',
                          padding: '5px 12px',
                          margin: '0 2px',
                          cursor: 'pointer',
                          borderRadius: '4px',
                          fontWeight: isActive ? 'bold' : 'normal',
                        }}
                      >
                        {index + 1}
                      </PaginationLink>
                    </PaginationItem>
                  )
                })}

                {/* next page */}
                <PaginationItem disabled={currentPage === totalPages}>
                  <PaginationLink
                    next
                    onClick={()=> setCurrentPage(prev => prev + 1)}
                    style={{
                      backgroundColor: '#f8f9fa',
                      color: '#007bff',
                      border: '1px solid #dee2e6',
                      padding: '5px 10px',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                    }}
                  />
                </PaginationItem>

                {/* last page */}
                <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      last
                      onClick={()=> setCurrentPage(totalPages)}
                      style={{
                        backgroundColor: '#f8f9fa',
                        color: '#007bff',
                        border: '1px solid #dee2e6',
                        padding: '5px 10px',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                      }}
                    />
                </PaginationItem>
              </Pagination>
          </div>
          </div>
          <Modal isOpen={isOpen} size='xl' backdrop="static" keyboard={false} toggle={null} fullscreen="xl" fade scrollable centered={true}>
            <ModalHeader close={<button type="button" className="btn-close" onClick={closeModal}/>}>
                  Customize Product
            </ModalHeader>
            <ModalBody>
                  <AddEditForm isEditMode={isEditMode} productData={selectedProduct} onClose={closeModal}/>
            </ModalBody>
          </Modal>
        </Card>
      </div>
    </div>
  )
}

export default ProductsCustomizationPage
